import React from 'react';
import ProjectCard from './ProjectCard';
import styles from './Projects.module.css';

const ProjectsGrid = ({ 
  projects, 
  onCardClick, 
  onUpdateStatus, 
  updatingStatus,
  navigate 
}) => {
  return (
    <div className={styles.projectsGrid}>
      {projects.map((project) => (
        <ProjectCard
          key={project.id}
          project={project}
          onClick={() => onCardClick(project.id)}
          onUpdateStatus={onUpdateStatus}
          isUpdating={updatingStatus[project.id]}
          navigate={navigate}
        />
      ))}
    </div>
  );
};

export default ProjectsGrid;